import Grid from "@material-ui/core/Grid";
import React, {PureComponent } from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { getDeviceContent } from "../../../state/ducks/devices/operations";
import { AppState } from "../../../state/store";
import DeviceContentContainer from "../../components/device/device-content-container/device-content-container";
import DeviceMenu from "../../components/device/device-menu/device-menu";
import DeviceMenuApp from "../../components/device/device-menu/device-menu-app";
import "./devices.scss";
import JmTitle from "../../components/jm-title/jm-title";


const mapDispatchToProps = (dispatch: Dispatch) => ({
  fetchDevices: async (dateFrom: Date, dateTo: Date) =>
    (await getDeviceContent(dateFrom, dateTo))(dispatch),
});

const mapStateToProps = (state: AppState) => {
  return {
    dateFrom: state.devicesReducer.dateFrom,
    dateTo: state.devicesReducer.dateTo,
  };
};

type Props = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>;

class Devices extends PureComponent<Props> {
  constructor(props: Props) {
    super(props);
    props.fetchDevices(props.dateFrom, props.dateTo);
  }

  public render() {
    return (
      <JmTitle title="Devices" shouldPrefixBrandName={true}>
        <div>
          <Grid container={true} className="desktop">
            <div className="devicesContainer">
              <DeviceMenu />
            </div>
            <div className="deviceContentContainer">
              <DeviceContentContainer />
            </div>
          </Grid>
          <div className="mobile">
            <DeviceMenuApp />
          </div>
        </div>
      </JmTitle>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Devices);
